module.exports = __webpack_public_path__ + "static/media/pickup-checkout.4d3543a2.svg";